import z from 'zod';

export const TicketDeflectionEmbedOptionSchema = z.enum([
  'snippet',
  'web-component',
  'iframe',
]);

export const TicketDeflectionIntegrationsSchema = z.enum([
  'topdesk',
  'freshdesk',
  'zendesk',
  'email',
]);

export const TicketDeflectionInputFieldType = z.enum([
  'dropdown',
  'input',
  'email',
]);

export const TicketDeflectionFeedbackTypeSchema = z.enum([
  'existing-form-usage',
]);

export const TicketDeflectionFieldSchema = z.object({
  fieldName: z.string(),
  fieldType: TicketDeflectionInputFieldType,
  isRequired: z.boolean(),
});

export const TicketDeflectionCreateSchema = z.object({
  aiAgent: z.string(),
  fields: TicketDeflectionFieldSchema.array(),
  integrations: TicketDeflectionIntegrationsSchema.array(),
  embedOption: TicketDeflectionEmbedOptionSchema,
});

export const TicketDeflectionFeedbackSchema = z.object({
  feedbackType: TicketDeflectionFeedbackTypeSchema,
});
